import type { ChatMentionsMenuItemType } from '@terra/ui-design-system';
import type { OpenMainContentTabInput, Tab } from '../store/layoutStore';

export const TERRA_TAB_MENTION_MIME = 'application/x-terra-tab-mention';

type MentionableTabType =
  | 'finding'
  | 'signal'
  | 'endpoint'
  | 'webpage'
  | 'executions'
  | 'skill'
  | 'skill-editor';

type MentionableTab = Extract<Tab, { type: MentionableTabType }>;

export type TabMentionDragPayload = {
  tab: Extract<OpenMainContentTabInput, { type: MentionableTabType }>;
};

const TAB_MENTION_TYPES = new Set<MentionableTabType>([
  'finding',
  'signal',
  'endpoint',
  'webpage',
  'executions',
  'skill',
  'skill-editor',
]);

export function isTabMentionable(tab: Tab): tab is MentionableTab {
  return TAB_MENTION_TYPES.has(tab.type as MentionableTabType);
}

export function serializeTabMentionPayload(tab: MentionableTab): string {
  const payload: TabMentionDragPayload = {
    tab: {
      id: tab.id,
      title: tab.title,
      type: tab.type,
      data: tab.data,
    } as TabMentionDragPayload['tab'],
  };
  return JSON.stringify(payload);
}

function isTabMentionDragPayload(
  value: TabMentionDragPayload | ChatMentionsMenuItemType,
): value is TabMentionDragPayload {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const tab = (value as TabMentionDragPayload).tab;
  if (!tab || typeof tab !== 'object') {
    return false;
  }
  return typeof tab.type === 'string';
}

export function parseTabMentionPayload(
  payload: string,
): TabMentionDragPayload | null {
  try {
    const parsed = JSON.parse(payload) as
      | TabMentionDragPayload
      | ChatMentionsMenuItemType;
    if (isTabMentionDragPayload(parsed)) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}
